import { render } from "./SearchAgeGender.vue?vue&type=template&id=46d3be15&scoped=true"
import script from "./SearchAgeGender.vue?vue&type=script&lang=js"
export * from "./SearchAgeGender.vue?vue&type=script&lang=js"

import "./SearchAgeGender.vue?vue&type=style&index=0&id=46d3be15&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d3be15"]])

export default __exports__